module.exports = __webpack_public_path__ + "img/eyein-partner-cogeco.42a78592.webp";